<template lang="pug">
  .text-view
    v-menu(v-model='openEditDialog' :nudge-width='400' absolute :close-on-content-click="false")
      template(v-slot:activator='{ on, attrs }')
        div(:style="content.styles" v-bind='attrs' v-on='on') {{ content.value }}
      v-card
        v-card-title.font-weight-bold.mt-n1 {{ $t('update_text') }}
        v-card-text.my-n2
          v-textarea(v-model="newText" hide-details outlined dense)
        v-card-actions
          v-spacer
          v-btn.mb-2(small text @click.native="openEditDialog = false; newText = content.value") {{ $t('cancel') }}
          v-btn.mb-2.mr-2(small depressed dark color="accent" @click="changeText()") {{ $t('update') }}

</template>

<script>
export default {
  name: 'TextView',
  props: ['content'],
  data: () => ({
    openEditDialog: false,
    newText: '',
  }),
  mounted () {
    this.newText = this.content.value
  },
  methods: {
    changeText () {
      this.content.value = this.newText
      this.openEditDialog = false
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "update_text": "Update Text"
  },
  "id": {
    "update_text": "Perbarui Teks"
  }
}
</i18n>